import { render, staticRenderFns } from "./ClaroEdificioSelectorDistrito.vue?vue&type=template&id=a635161e"
import script from "./ClaroEdificioSelectorDistrito.vue?vue&type=script&lang=js"
export * from "./ClaroEdificioSelectorDistrito.vue?vue&type=script&lang=js"
import style0 from "./ClaroEdificioSelectorDistrito.vue?vue&type=style&index=0&id=a635161e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports